export const PRODUCT_VISIBILITY_OPTIONS = [
  {
    value: "DRAFT",
    label: "Draft",
    description:
      "Only you can see this in the portal. It is not on the website.",
  },
  {
    value: "UNPUBLISHED",
    label: "Unpublished",
    description: "All portal users can see this. It is not on the website.",
  },
  {
    value: "PUBLISHED",
    label: "Published",
    description: "All portal users and website visitors can see this.",
  },
  {
    value: "DEPRECATED",
    label: "Deprecated",
    description: "All portal users can see this. It is not on the website.",
  },
];
